module.exports = __webpack_public_path__ + "img/lucas.4f803af5.svg";